export default "__VITE_ASSET__CCh4PuRw__"